import { css } from "@emotion/react";
import { omit } from "lodash/fp";

import {
  useThemeProps,
  Avatar,
  ContactCard,
  Icon,
  Link,
  Typography,
} from "../../wsui/base";

const SOCIAL_MEDIA_NAMES = {
  facebook: "Facebook",
  linkedin: "LinkedIn",
  twitter: "Twitter",
  instagram: "Instagram",
};

export default function ContactsModule(props) {
  props = useThemeProps({ props, name: "MunicipioContactsModule" });
  let {
    contacts,
    avatarBorder = "none",
    avatarBorderColor = "",
    ...restProps
  } = omit(["title", "description"], props);
  const linkStyle = css`
    display: flex;
    gap: 0.5rem;
    align-items: center;
    font-weight: 500;
  `;
  return (
    <div {...restProps}>
      {contacts.map(
        (
          {
            address,
            administrationUnit,
            email,
            firstName,
            lastName,
            image,
            openingHours,
            other,
            phoneNumbers,
            socialMedia,
            visitingAddress,
            workTitle,
          },
          index,
        ) => {
          return (
            <ContactCard
              key={index}
              media={
                <Avatar
                  image={image}
                  border={avatarBorder}
                  borderColor={avatarBorderColor}
                />
              }
              {...restProps}
            >
              {firstName && (
                <div
                  css={css`
                    margin-bottom: 12px;
                  `}
                >
                  {firstName && (
                    <Typography variant="h4">
                      {lastName ? `${firstName} ${lastName}` : firstName}
                    </Typography>
                  )}
                  {workTitle && (
                    <Typography variant="p">{workTitle}</Typography>
                  )}
                  {administrationUnit && (
                    <Typography variant="p">{administrationUnit}</Typography>
                  )}
                </div>
              )}
              {email && (
                <div css={linkStyle}>
                  <Icon name="email" color="primary" />
                  <Link href={`mailto:${email}`} color="primary">
                    {email}
                  </Link>
                </div>
              )}
              {phoneNumbers &&
                phoneNumbers.map(({ number, type }, index) => (
                  <div css={linkStyle} key={index}>
                    <Icon name={type} color="primary" />
                    <Link href={`tel:${number}`} color="primary">
                      {number}
                    </Link>
                  </div>
                ))}
              {socialMedia &&
                socialMedia.map(({ media, url }, index) => {
                  return (
                    url && (
                      <div css={linkStyle} key={index}>
                        <Icon name={`${media}-bold`} color="primary" />
                        <Link href={url} key={index}>
                          <span>{SOCIAL_MEDIA_NAMES[media]}</span>
                        </Link>
                      </div>
                    )
                  );
                })}
              {address && (
                <div>
                  <Typography variant="h5">Address</Typography>
                  {address}
                </div>
              )}
              {visitingAddress && (
                <div>
                  <Typography variant="h5">Visiting address</Typography>
                  {visitingAddress}
                </div>
              )}
              {openingHours && (
                <div>
                  <Typography variant="h5">Opening hours</Typography>
                  {openingHours}
                </div>
              )}
              {other && <div>{other}</div>}
            </ContactCard>
          );
        },
      )}
    </div>
  );
}
